// src/i18n/es/benchmark.ts
// "Internal benchmark" (w7.u5) - route /benchmark. Chain tier feature (D22):
// ranking by arrivals resolved without reception among the property's own
// chain siblings, with the chain median marked. A user who sees one hotel of
// the chain gets only that hotel and the median (API `scope: "own"`). Metric
// labels come verbatim from the API where used directly; only the page
// chassis and table headers are translated here.
export const benchmark = {
  name: 'Comparativa entre hoteles |||| Comparativa entre hoteles',
  subtitle: 'Llegadas resueltas sin recepción en el periodo elegido, frente a la mediana de su cadena',

  summary: {
    title: 'Hoteles con datos',
    withRates: '%{count} de %{total} hoteles de la cadena tienen datos suficientes en este periodo.',
  },

  ranking: {
    title: 'Clasificación por llegadas resueltas sin recepción',
    property: 'Hotel',
    containment: 'Resueltas sin recepción',
    medianMarker: 'Mediana de la cadena: %{value}',
    empty: 'No hay otros hoteles en la misma cadena, o ninguno tiene datos suficientes.',
    medianMissing: 'Sin mediana de la cadena: %{reason}',
  },

  own: {
    title: 'Su hotel frente a la mediana de la cadena',
    titleMany: 'Sus hoteles frente a la mediana de la cadena',
    median: 'Mediana de la cadena',
    note: 'Con su acceso solo se muestra su hotel; los demás hoteles de la cadena cuentan para la mediana, pero no aparecen.',
    noteMany: 'Con su acceso solo se muestran sus hoteles; los demás hoteles de la cadena cuentan para la mediana, pero no aparecen.',
  },

  export: {
    property: 'Hotel',
    containment: 'Resueltas sin recepción',
    remedy: 'Remedio',
  },

  help: {
    title: 'Comparativa entre hoteles',
    description:
      'Compara qué parte de las llegadas de cada hotel de la cadena se resolvió sin pasar por recepción, con la mediana de la cadena marcada, y cuántos hoteles tienen datos suficientes en el periodo. Quien ve toda la cadena ve la clasificación completa; quien ve un solo hotel ve su hotel frente a la mediana.',
    features: {
      list: 'Un hotel sin cifra aparece al final, sin número de puesto, con el motivo (muestra insuficiente, sin reservas recibidas, entrega de eventos no fiable o día de negocio sin configurar), nunca con un cero. Los hoteles dados de baja o fusionados no cuentan.',
    },
    tips: {
      property: 'Cambie de hotel arriba a la izquierda; el periodo por defecto son los últimos 30 días.',
    },
  },
};

export default benchmark;
